export const ApiUrl = process.env.REACT_APP_API_URL;
export const CloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
export const UploadPreset = process.env.REACT_APP_UPLOAD_PRESET;
export const LandingUrl = process.env.REACT_APP_LANDING_PAGE_URL;
